import React, { useState, useEffect, createContext } from 'react';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState({
    isAuthenticated: false,
    info: null,
  });

  const logOut = () => {
    console.log('Removiendo token de witwan');

    localStorage.removeItem('tower_witwan_info');

    setUser({
      isAuthenticated: false,
      info: null,
    });
  };

  useEffect(() => {
    // Miramos si existe un token en el localStorage con la informacion del usuario de witwan
    const witwanToken = JSON.parse(localStorage.getItem('tower_witwan_info'));

    if (witwanToken) {
      console.log('Existe un token de witwan, analizando caducación..');
      const { iat } = witwanToken;
      const now = new Date().getTime();
      const diff = now - iat;

      // Si la diferencia es menor a 8hs mantenemos el token
      if (diff < 8 * 60 * 60 * 1000) {
        setUser({
          isAuthenticated: true,
          email: witwanToken.email,
          id: witwanToken.id,
          iat: witwanToken.iat,
          name: witwanToken.name,
          credentials: witwanToken.credentials,
        });
      } else {
        console.log('Removiendo token witwan, token expirado.');
        // De lo contrario eliminamos el token del storage
        localStorage.removeItem('tower_witwan_info');
      }
    }
  }, []);

  return <AuthContext.Provider value={{ user, logOut }}>{children}</AuthContext.Provider>;
}
